import {
  CHANGE_TUTORIAL_INDEX,
  TOGGLE_COMPANY_LIST,
  TOGGLE_RESET_PASSWORD_VIEW,
  TOGGLE_SIGN_OUT_MODAL,
  TOGGLE_TUTORIAL_MODAL,
} from 'actions/actionTypes';
import { BackendUiActionTypes, BackendUiState } from 'types/backend/ui';

export const initialState: BackendUiState = {
  isOpenSignOutModal: false,
  isFinishedResetPassword: false,
  isOpenTutorialModal: false,
  tutorialIndex: 1,
  isOpenCompanyList: false,
};

const backendUiReducer = (state = initialState, action: BackendUiActionTypes): BackendUiState => {
  switch (action.type) {
    case TOGGLE_SIGN_OUT_MODAL: {
      const { flag } = action;
      return {
        ...state,
        isOpenSignOutModal: flag,
      };
    }
    case TOGGLE_RESET_PASSWORD_VIEW: {
      return {
        ...state,
        isFinishedResetPassword: true,
      };
    }
    case TOGGLE_TUTORIAL_MODAL: {
      const { flag } = action;
      return {
        ...state,
        isOpenTutorialModal: flag,
        tutorialIndex: initialState.tutorialIndex,
      };
    }
    case CHANGE_TUTORIAL_INDEX: {
      const { index } = action;
      return {
        ...state,
        tutorialIndex: index,
      };
    }
    case TOGGLE_COMPANY_LIST: {
      const { flag } = action;
      return {
        ...state,
        isOpenCompanyList: flag,
      };
    }
    default: {
      return state;
    }
  }
};

export default backendUiReducer;
